/**
 * Route constants — mirrors Flutter's CoreRoute (route_names.dart).
 * Every route string is kept identical to the Flutter route.
 */
export const ROUTES = {
  HOME: '/home',
  ABOUT_US: '/aboutUs',
  LOGIN: '/login',
  SIGN_UP: '/signUp',
  JOB_APPLICATION: '/jobApplication',
  JOB_DESCRIPTION_1: '/1',
  JOB_DESCRIPTION_2: '/2',
  EXTRACTED_RESUME: '/search_by_resume',
  JOBS: '/jobs',
  JOBS_DETAIL: '/jobs/:id',
  CANDIDATE_FORM: '/candidateApplicationForm',
  PROFILE: '/profile',
  APPLICATION: '/application',
  APPLICATION_WITH_ID: '/application/:id',
  EASY_APPLY: '/easyApplyApplication',
  EASY_APPLY_WITH_ID: '/easyApplyApplication/:id',
  EDIT_PROFILE: '/editProfile',
  SAVED_JOBS: '/savedJobs',
  VIEW_JOBS: '/viewJobs',
  /** Flutter child routes use an underscore prefix (routing_config.dart profileChildRoutes) */
  VIEW_JOBS_APPLIED: '/viewJobs/_applied',
  VIEW_JOBS_INVITED: '/viewJobs/_invited',
  VIEW_JOBS_RECOMMENDED: '/viewJobs/_recommended',
  VIEW_JOBS_SAVED: '/viewJobs/_saved',
  RESET_PASSWORD: '/resetPassword',
  VERIFY_EMAIL: '/verifyEmail',
  DUPLICATE_ACCOUNT: '/duplicateAccount',
  MFA: '/mfa',
  EMAIL_VERIFIED: '/emailVerified',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
